<template>
  <div>
    <LockLoader v-show="isLoading"
      asset="lock-icon.svg"
      :text="loadingText"
    />
    <div v-show="!isLoading" class="response-loading">
      <LockLoader v-show="!isError && !isRetry"
        asset="check-icon.svg"
        backgroundClass="primary-extra-light"
        :text="successText"
        :isToLoad="false"
      />

      <LockLoader v-show="!hideErrorLoading && (isError || isRetry || showRetryReasons)"
        asset="o-warning-icon.svg"
        backgroundClass="warning-light"
        :text="errorMsg"
        :isToLoad="false"
      />
    </div>
  </div>
</template>

<script>
import LockLoader from '@/components/common/LockLoader.vue';

import Logger from '../../../lib/logger';

export default {
  name: 'onboarding-loading',
  components: { LockLoader },
  props: {
    loadingText: {
      type: String,
      default: 'Verificando imagem...',
    },
    successText: {
      type: String,
      default: 'Foto enviada',
    },
    errorText: {
      type: String,
      default: 'Imagem inválida',
    },
    onSucessGoTo: {
      type: String,
    },
    onRetryGoTo: {
      type: String,
    },
    onErrorGoTo: {
      type: String,
      // required: true,
    },
    onShowRetryReasons: {
      type: String,
      defaul: null,
    },
    hideErrorLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isError: false,
      isRetry: false,
      isLoading: true,
      showRetryReasons: false,
      errorMsg: this.errorText,
    };
  },
  methods: {
    handleResponse({ error, retry, showRetryReasons, nextRoute } = {}) {
      this.isLoading = false;
      this.isError = !!error;
      this.isRetry = !!retry;
      this.showRetryReasons = !!showRetryReasons;
      setTimeout(() => {
        if (error) {
          Logger.error(error);
          return this.$router.replace({ name: this.onErrorGoTo, query: this.$route.query });
        } if (retry) {
          if (showRetryReasons && this.onShowRetryReasons) {
            return this.$router.replace({
              name: this.onShowRetryReasons,
              query: this.$route.query,
            });
          }
          return this.$router.replace({ name: this.onRetryGoTo, query: this.$route.query });
        }
        return this.$router.replace({
          name: nextRoute || this.onSucessGoTo,
          query: this.$route.query,
        });
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
  .response-loading {
    height: 100vh;

    display: flex;
    justify-content: center;
    align-items: center;

    div {
      display: flex;
      flex-direction: column;

      span {
        font-size: 20px;
        line-height: 28px;
        margin-top: 20px;
      }
    }
  }
</style>
